import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../../config/api';

interface Category {
  id: string;
  name: string;
  parent_id?: string;
}

export const useProductCategories = () => {
  const [mainCategories, setMainCategories] = useState<Category[]>([]);
  const [allSubCategories, setAllSubCategories] = useState<Category[]>([]);
  const [filteredSubCategories, setFilteredSubCategories] = useState<Category[]>([]);
  const [selectedMainCategory, setSelectedMainCategory] = useState<string>('');

  // Load main categories
  useEffect(() => {
    axios
      .get(API_ENDPOINTS.categoriesMain)
      .then(res => {
        setMainCategories(res.data);
        if (res.data.length > 0) {
          setSelectedMainCategory(res.data[0].id);
        }
      })
      .catch(error => {
        console.error('Ana kategoriler yüklenemedi:', error);
      });
  }, []);

  // Load all sub categories (for display in table)
  useEffect(() => {
    axios
      .get(API_ENDPOINTS.categoriesAllSub)
      .then(res => setAllSubCategories(res.data))
      .catch(error => {
        console.error('Alt kategoriler yüklenemedi:', error);
      });
  }, []);

  // Load filtered sub categories based on selected main category
  useEffect(() => {
    if (!selectedMainCategory) {
      return;
    }

    axios
      .get(API_ENDPOINTS.categoriesSub(selectedMainCategory))
      .then(res => setFilteredSubCategories(res.data))
      .catch(error => {
        console.error('Filtrelenmiş kategoriler yüklenemedi:', error);
      });
  }, [selectedMainCategory]);

  // Helper functions
  const getMainCategoryName = (id: string | number): string => {
    const stringId = String(id);
    const category = mainCategories.find(cat => cat.id === stringId);
    return category ? category.name : stringId;
  };

  const getSubCategoryName = (id: string | number): string => {
    const stringId = String(id);
    const category = allSubCategories.find(cat => cat.id === stringId);
    return category ? category.name : stringId;
  };

  const handleMainCategoryChange = (categoryId: string) => {
    setSelectedMainCategory(categoryId);
  };

  return {
    mainCategories,
    allSubCategories,
    filteredSubCategories,
    selectedMainCategory,
    getMainCategoryName,
    getSubCategoryName,
    handleMainCategoryChange,
  };
};
